var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvancedButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.833 147.5C256 148.333 254.333 149.167 253.5 150L233.5 153.333L247.667 183.333C249.333 186.667 247.667 190 244.333 191.667L221 202.5C220.167 203.333 219.333 203.333 218.5 203.333C216 203.333 213.5 201.667 212.667 200L199.333 170L183.5 182.5C182.667 183.333 181 184.167 179.333 184.167C176 184.167 172.667 181.667 172.667 177.5V82.5001C172.667 78.3334 175.167 75.8334 179.333 75.8334C181 75.8334 182.667 76.6668 183.5 77.5001L256 139.167C258.5 140.833 259.333 145 256.833 147.5ZM156 120H139.333V53.3334H272.667V120H259.333L277.667 135.833C284.333 133.333 288.5 127.5 288.5 120V53.3334C288.5 44.1667 281 36.6667 271.833 36.6667H139.333C130.167 36.6667 122.667 44.1667 122.667 53.3334V120C122.667 129.167 130.167 136.667 139.333 136.667H156V120Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3379_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3379_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(366 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3379_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(372 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3379_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(320 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3379_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(326 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedButton);
export default __webpack_public_path__ + "static/media/advanced-button.fea8573256199fea8a7ce0b97b4ad02a.svg";
export { ForwardRef as ReactComponent };